export default __webpack_public_path__ + "scripts/resource/e44d65e7dc28a698471c3bfc3dfa23a5.svg";